import { createReducer } from 'immutable-reducers';
import { fromJS, Map } from 'immutable';

import { VERIFY_UNIT, VISIT_AND_UNITS } from '../constants/actionTypes';
import * as STATUS from '../constants/unitVerificationStatus';

const INITIAL_STATE = {
    status: STATUS.NOT_VERIFIED,
    dims: []
};

export default createReducer(['unitVerification'], (state = fromJS(INITIAL_STATE), action) => {

    switch (action.type) {

        case VERIFY_UNIT.REQUEST:
            return state.set('status', STATUS.VERIFYING);

        case VISIT_AND_UNITS.CLEAR:
        case VERIFY_UNIT.RESET:
        case VERIFY_UNIT.ERROR:
            return fromJS(INITIAL_STATE);

        case VERIFY_UNIT.SUCCESS:
            return state.set('status', action.ok === 1 ? STATUS.VERIFIED_OK : STATUS.VERIFIED_NOK)
                .set('dims', action.dims);

        default:
            break;
    }

    return state;
});